var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('Transition',{attrs:{"appear":""}},[_c('div',{class:_vm.$style.loadingIcon,attrs:{"name":"sync","spin":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }